import { render, staticRenderFns } from "./EWLimitConfigLogShow.vue?vue&type=template&id=1b7406d1&"
import script from "./EWLimitConfigLogShow.vue?vue&type=script&lang=js&"
export * from "./EWLimitConfigLogShow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports